import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import AwesomeLoaders from "../pages/docs/code/rug";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h2 {...{
      "id": "getting-started"
    }}><a parentName="h2" {...{
        "href": "#getting-started",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`Getting Started`}</h2>
    <p>{`The easiest way to use one of the loaders from `}{`‌`}<AwesomeLoaders mdxType="AwesomeLoaders" />{` is to install the NPM package and import the particular loader to use it.`}</p>
    <h3 {...{
      "id": "install-npm-package"
    }}><a parentName="h3" {...{
        "href": "#install-npm-package",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`Install NPM Package`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm install react-awesome-loaders
`}</code></pre>
    <h3 {...{
      "id": "import-and-use"
    }}><a parentName="h3" {...{
        "href": "#import-and-use",
        "aria-hidden": true,
        "className": "anchor"
      }}><svg aria-hidden="true" height="16" version="1.1" viewBox="0 0 16 16" width="16"><path fillRule="evenodd" d="M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"></path></svg></a>{`Import And Use`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "highlight={1,6}",
        "highlight": "{1,6}"
      }}>{`import { LoaderName } from "react-awesome-loaders"
...
function LoadingComponent(props) {
    return (
        ...
        <LoaderName {...passParametersToCustomise} />
        ...
    );
}
export default LoadingComponent
`}</code></pre>
    <p>{`The loaders are very flexible to import and use wherever you want and in any web framework that uses NPM.`}<br parentName="p"></br>{`
`}{`The loaders are auto-responsive. i.e. The size of loader automatically adjusts itself on smaller screen sizes.`}<br parentName="p"></br>{`
`}{`Ofcourse, you can set different sizes for different screens by passing props `}<inlineCode parentName="p">{`desktopSize`}</inlineCode>{` and `}<inlineCode parentName="p">{`mobileSize`}</inlineCode>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      